import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';

@Component({
    selector: 'app-kpi-config-four',
    templateUrl: './kpi-config-four.component.html',
    styleUrls: ['./kpi-config-four.component.scss'],
})
export class KpiConfigFourComponent implements OnInit {
    grid: GridDataResult;
    sortable = {
        mode: 'single',
        allowUnsort: true,
    };

    sort: SortDescriptor[] = [
        {
            field: 'clientKPIDescription',
            dir: 'asc',
        },
    ];

    allResults: boolean = false;
    scrollable = 'scrollable';

    @Input() data: any[];
    @Input() loading: boolean;
    constructor() {}

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.data?.previousValue == undefined && changes?.data?.currentValue != undefined) {
            this.reloadGrid();
        }
    }

    reloadGrid() {
        try {
            let data = this.data.filter((x) => x.isActive === true);

            this.grid = {
                data: orderBy(data, this.sort),
                total: data.length,
            };
        } catch (e) {}
    }

    sortChange(sort: SortDescriptor[]): void {
        this.sort = sort;
        this.reloadGrid();
    }
}
